import React, { useMemo } from 'react';

import { RenderMachine } from 'components/Flow/RenderMachine';
import { useQueryParams } from 'utils/useQueryParams';

import { setStepParam } from '../utils';

import { organizationNotFoundMachine } from './machine';

export const OrganizationNotFound = ({
  onClose,
  onCreateGov,
}: {
  onClose: () => void;
  onCreateGov: () => void;
}) => {
  const urlSearchParams = useQueryParams();
  const machine = useMemo(
    () => organizationNotFoundMachine(urlSearchParams?.get('step') || 'organizationTypeSelection'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return (
    <RenderMachine
      machine={machine}
      onTransition={(state) => setStepParam(state.value as string)}
      options={{
        context: {},
        actions: {
          close: onClose,
          createGov: onCreateGov,
        },
      }}
    />
  );
};
